import React from "react";
import { ClearAllProps } from "@usereactify/search";

export type ClearAllButtonProps = React.ComponentProps<
    NonNullable<ClearAllProps["render"]>
>;

export const ClearAllButton: React.FC<ClearAllButtonProps> = (props) => {
    return <button className="underline uppercase" onClick={props.clearAll}>Clear Filters</button>
};
